export function cancelDeliveryGroupOrders(assignedDeliveryGroups, deliveryGroupId, orderIds = undefined) {
    const deliveryGroups = [...assignedDeliveryGroups];
    const deliveryGroupIndex = deliveryGroups.findIndex(deliveryGroup => deliveryGroup.id === deliveryGroupId);
    const deliveryGroup = deliveryGroups[deliveryGroupIndex];

    if (!orderIds)
        orderIds = deliveryGroup.route.map(deliveryOrder => deliveryOrder.order_id);

    const {deliveryOrders, removedDeliveryOrders} = popDeliveryOrders(deliveryGroup.route, orderIds);

    if (!deliveryGroup.aborted_orders)
        deliveryGroup.aborted_orders = [];

    deliveryGroup.route = deliveryOrders;
    deliveryGroup.aborted_orders.push(...removedDeliveryOrders);

    if (deliveryGroup.route.length === 0)
        deliveryGroups.splice(deliveryGroupIndex, 1);

    return deliveryGroups;
}

function popDeliveryOrders(oldDeliveryOrders, orderIds) {
    const arrayOrderIds = Array.isArray(orderIds) ? orderIds : [orderIds];
    const removedOrders = [];
    const deliveryOrders = [];

    oldDeliveryOrders.forEach(deliveryOrder => {
        if (arrayOrderIds.includes(deliveryOrder.order_id))
            removedOrders.push(deliveryOrder);
        else
            deliveryOrders.push(deliveryOrder);
    });

    return {deliveryOrders: deliveryOrders, removedDeliveryOrders: removedOrders}
}